<template>
    <div>
        <div>
            <el-row type="flex" justify="center">
                <el-col :span="12">
                    {{app ? app.app_name : ''}}.检查系统
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <h5>{{jcdx_name}}</h5>
                    <el-row v-for="(item, item_index) in items" :label="item.item_name">
                        
                        <wc-radio :label="item.item_name" @setReqdata="setReqData" :options="item.options"></wc-radio>
                    </el-row>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-button type="primary" @click="submit">提交</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import WcRadio from './cell/WcRadio.vue'
export default {
    created() {
        //console.log(this.$route)
        this.app_id = this.$route.params.app_id
        this.jcdx_id = this.$route.query.jcdx_id
        this.jcdx_name = this.$route.query.jcdx_name
        //this.setReqData()
        this.getApp()
    },
    components: {

        WcRadio
    },
    data() {
        return {
            app_id: '',
            app: null,
            jcdx_id: '',
            jcdx_name: '',
            items: [],
            req_data: []
        }
    },
    methods: {
        getApp() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data
                this.app = res
                this.getItem()
            }).catch((err) => {
                //console.log(err);
            })
        },
        getItem() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id + '/items'
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.items = res
                this.setReqData(false)
            }).catch((err) => {
                //console.log(err);
            })
        },
        setReqData(data) {
            //组装请求数据
            //console.log(option)
            if (!data) {
                this.req_data = []
                let items = this.items
                for (let j = 0; j < items.length; j++) {
                    this.req_data.push({
                        item_id: items[j].item_id,
                        option_id: items[j].options[0].option_id,
                        jcdx_id: this.jcdx_id
                    })
                }

            } else {
                let items = this.items
                let req_data = this.req_data
                for (let i = 0; i < items.length; i++) {
                    for (let j = 0; j < items[i].options.length; j++) {
                        if (items[i].options[j].option_id == data.option_id) {
                            this.req_data.splice(i, 1, {
                                item_id: items[i].item_id,
                                option_id: data.option_id,
                                jcdx_id: this.jcdx_id
                            })
                           

                        }
                    }
                }
            }


        },
        radioCheck(option) {
            console.log(option)
        },
        submit() {
            let _this = this
            let items = this.items
            let msg = this.jcdx_name
            for (let i = 0; i < items.length; i++) {
                for (let j = 0; j < items[i].options.length; j++) {
                    if (this.req_data[i].option_id == items[i].options[j].option_id) {
                        msg += ' ' + items[i].item_name + ':' + items[i].options[j].option_name + ' '
                    }
                }
            }
            this.$confirm(msg, '请确认', {
                confirmButtonText: '确认提交',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                axios({
                        method: 'post',
                        headers: {
                            "Authorization": localStorage.getItem('token')
                        },
                        url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id + '/res',
                        data: this.req_data
                    })
                    .then(function(response) {
                        //console.log(response)

                        _this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        _this.$router.go(-1)
                    })
                    .catch((err) => {
                        //console.log(err.response)
                        let err_data = err.response.data.err_msg
                        this.$message({
                            message: err_data,
                            type: 'error'
                        })
                    })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });



        }
    }
}
</script>